import { ProcessedCourse } from "@/common/course/types";

export function getCourseStartDate(course: ProcessedCourse) {
  const { start } = course.activeCourseRun || {};
  const { startDate } = course.additionalMetadata[0] || {};
  return startDate || start;
}

export function getCourseEndDate(course: ProcessedCourse) {
  const { end } = course.activeCourseRun || {};
  const { registrationDeadline } = course.additionalMetadata[0] || {};
  return registrationDeadline || end;
}
